import { Tag } from "antd";
import React, { useEffect, useState } from "react";
import { getViewInfo, ZAttrViewInfo } from "src/common/attrView";
import {
  ZDictRef,
  zDictRef,
  ZTagModeDictRef,
} from "src/common/attrView/componentsDefs";
import { seedSeparators } from "src/common/attrView/viewFormItems/Separator";
import { onError } from "src/common/onError";
import { zAttrLabelMeta } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelMeta";
import { AttrTypeName } from "src/types/AttrType";
import { ZAttribute } from "src/types/ZAttribute";
import { classNames } from "src/common/classNames";
import { ZUid } from "src/types/zUid";
import { MakeLabelParams } from "../../../types/MakeLabelParams";
import styles from "./DictRef.module.less";
import { getAttrLabelTreeData } from "../../../utils/getAttrLabelTreeData";
import { SimpleText } from "../../SimpleText/SimpleText";

type Option = { id: ZUid; value: string | null };

const getTagsMultipleColor = (viewProps: ZDictRef | undefined, atrId: string) =>
  viewProps?.modeMeta?.tagsColorMap?.[atrId];

const getTagColor = (viewProps: ZDictRef | undefined) =>
  viewProps?.modeMeta?.tagColor;

const createMuliTag = (
  viewProps: ZDictRef | undefined,
  viewInfo: ZAttrViewInfo | undefined,
  options: Option[],
) => {
  const labelsWithSeparator = seedSeparators(
    options.map((opt) => ({
      content: (
        <Tag
          color={getTagsMultipleColor(viewProps, String(opt.id))}
          style={{ maxWidth: "100%" }}
        >
          <SimpleText values={[opt.value]} viewInfo={viewInfo} />
        </Tag>
      ),
      key: opt.id,
    })),
    viewInfo?.appearance?.view?.separator,
  );

  return (
    <div className={styles.box} style={viewInfo?.styles ?? undefined}>
      {labelsWithSeparator}
    </div>
  );
};

const createSimpleLable = (
  viewInfo: ZAttrViewInfo | undefined,
  options: Option[],
) => {
  const labelsWithSeparator = seedSeparators(
    options.map((opt) => ({ content: opt.value, key: opt.id })),
    viewInfo?.appearance?.view?.separator,
  );
  return (
    <SimpleText
      values={labelsWithSeparator}
      viewInfo={viewInfo}
      className={styles.box}
    />
  );
};

const createTag = (
  viewProps: ZDictRef | undefined,
  viewInfo: ZAttrViewInfo | undefined,
  options: Option[],
) => (
  <Tag color={getTagColor(viewProps)} style={{ maxWidth: "100%" }}>
    {createSimpleLable(viewInfo, options)}
  </Tag>
);

const createLabel = (
  attr: ZAttribute,
  options: Option[],
  multiple: boolean,
) => {
  try {
    const viewInfo = getViewInfo(attr.viewType);
    const viewProps = zDictRef.parse(viewInfo?.component);
    const lablelMap: Record<ZTagModeDictRef, React.ReactNode> = {
      tagsMulti: createMuliTag(viewProps, viewInfo, options),
      tag: createTag(viewProps, viewInfo, options),
      standart: createSimpleLable(viewInfo, options),
    };
    const mode = viewProps?.mode;
    return (
      <div className={classNames([[multiple, styles.multiple]])}>
        {mode ? lablelMap[mode] : lablelMap.standart}
      </div>
    );
  } catch (error) {
    onError(error);
    return null;
  }
};

type PropsDictRef2 = {
  params: MakeLabelParams;
};

export const DictRef3: React.FC<PropsDictRef2> = ({ params }) => {
  const [label, setLabel] = useState<React.ReactNode>([]);
  const init = () => {
    try {
      const { attribute } = params;
      const attrTreeData = getAttrLabelTreeData(
        params.attribute,
        params.labelTreeData,
      );
      if (!attrTreeData) return;
      const meta = zAttrLabelMeta.parse(attrTreeData?.attrLabelMeta);
      if (
        !(
          meta.type === AttrTypeName.dictSingle ||
          meta.type === AttrTypeName.dictMulti
        )
      )
        return;
      const { links } = meta;
      const vals = Object.keys(links);
      const opts = vals.map((v) => {
        const labelKey = Number(links[v]?.[0]);
        const value = attrTreeData?.labels?.[labelKey] ?? null;
        return { id: v, value };
      });
      setLabel(createLabel(attribute, opts, vals.length > 1));
    } catch (error) {
      onError(error);
    }
  };
  useEffect(() => {
    init();
  }, []);
  return label;
};
